
import { useState, useCallback } from 'react';

interface CommandEntry {
  command: string;
  response: string;
  isError?: boolean;
}

export function useCommandHistory() {
  const [history, setHistory] = useState<CommandEntry[]>([]);
  const [future, setFuture] = useState<CommandEntry[]>([]);

  const addEntry = useCallback((entry: CommandEntry) => {
    setHistory(prev => [...prev, entry]);
    setFuture([]);
  }, []);

  const undo = useCallback(() => {
    setHistory(prev => {
      if (prev.length === 0) return prev;
      setFuture(f => [prev[prev.length - 1], ...f]);
      return prev.slice(0, -1);
    });
  }, []);

  const redo = useCallback(() => {
    setFuture(prev => {
      if (prev.length === 0) return prev;
      setHistory(h => [...h, prev[0]]);
      return prev.slice(1);
    });
  }, []);

  const clear = useCallback(() => {
    setHistory([]);
    setFuture([]);
  }, []);

  return { history, addEntry, undo, redo, clear, canUndo: history.length > 0, canRedo: future.length > 0 };
}
